import { createActionsHook } from 'src/lib/sweetState';

import { DebugStore } from './DebugStore';

export const useDebugActions = createActionsHook(DebugStore);
